import React, { useMemo, useState } from 'react';

import { IconButton, Typography, styled, Box, Icon } from '@liscio/ui';
import * as flags from 'country-flag-icons/react/3x2';

import { AutocompleteOverlaySelect } from 'components';

export interface CountrySelectProps {
  options: Array<{ value?: string; label?: string }>;
  value?: string | null;
  onChange: (newCountry: string) => void;
  disabled?: boolean;
}

const IconWrapper = styled(Box)(({ theme }) => ({
  width: '25px',
  height: '25px',
  '& svg': {
    border: `solid 1px ${theme.palette.common.blueGray[200]}`,
  },
}));

export const CountrySelect: React.FC<CountrySelectProps> = ({
  options,
  value,
  onChange,
  disabled,
}) => {
  const [isOverlayOpen, setIsOverlayOpen] = useState(false);
  const [searchString, setSearchString] = useState('');
  const flagIcon = useMemo(() => {
    const FlagComponent = flags?.[value as keyof typeof flags];
    if (FlagComponent) return <FlagComponent />;
    return <Icon icon="phone" />;
  }, [value]);

  const filteredOptions = useMemo(() => {
    if (!searchString) {
      return options;
    }
    return options.filter((elem) =>
      elem?.label?.toLowerCase()?.includes(searchString.toLowerCase())
    );
  }, [options, searchString]);

  return (
    <>
      <IconButton onClick={() => setIsOverlayOpen(true)} disabled={disabled}>
        <IconWrapper>{flagIcon}</IconWrapper>
      </IconButton>
      <AutocompleteOverlaySelect
        open={isOverlayOpen}
        closeFunction={() => setIsOverlayOpen(false)}
        data={filteredOptions}
        keyExtractor={({ value }) => value || ''}
        onSearchChange={(newSearchString) => {
          setSearchString(newSearchString);
        }}
        onSelect={({ value }) => {
          if (value) {
            onChange(value);
            setIsOverlayOpen(false);
          }
        }}
        title="Select Country"
        searchString={searchString}
        renderItem={({ label }) => <Typography>{label}</Typography>}
      />
    </>
  );
};

export default CountrySelect;
